import React from 'react'
import { Checkbox, Col, Divider, Flex, Form, Row, Typography } from 'antd'
import { Control, Controller, FieldError } from 'react-hook-form'
import { IModule } from 'src/app/shared/models/store.model'
import { useWindowSize } from 'src/app/shared/hooks/useWindowSize'

type IData = {
  label: string
  value: string
  submoduleItemOrderIndex: number
  disabled: boolean
}

type Props = {
  options: IModule[]
  control: Control<any>
  name: string
  keyElement: string
  defaultValue?: string[]
  value?: string[]
  handleChange?: (e: string[]) => void
  formErrors?: FieldError
}

export const FormCheckboxGroup: React.FC<Props> = ({
  options,
  control,
  name,
  keyElement,
  defaultValue,
  value,
  handleChange,
}) => {
  const { mode } = useWindowSize()
  return (
    <Flex style={{ width: '100%' }}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange } }) => (
          <Checkbox.Group
            onChange={(e) => {
              onChange(e)
              handleChange && handleChange(e)
            }}
            defaultValue={defaultValue}
            {...(value && { value: value })}
          >
            {options?.length > 0 &&
              options?.map((items, index) => {
                let optionCol1: IData[] = []
                let optionCol2: IData[] = []
                items.submoduleItemShortInfos
                  .map((sub) => ({
                    label: sub.submoduleItemName,
                    value: sub.submoduleItemId,
                    submoduleItemOrderIndex: sub.submoduleItemOrderIndex,
                    disabled: false,
                  }))
                  .sort((e) => e.submoduleItemOrderIndex)
                  ?.map((item, index: number) => {
                    if (index % 2 === 0) {
                      optionCol1.push(item)
                    } else {
                      optionCol2.push(item)
                    }
                    return item
                  })

                return (
                  <Flex vertical key={`module` + index} style={{ width: '100%' }}>
                    <Flex vertical>
                      <Typography className='module-title'>{items?.moduleItemName}</Typography>
                      <Flex vertical>
                        <Form.Item style={{ marginBottom: 4 }}>
                          {optionCol1.map((item: IData, index) => {
                            return (
                              <Flex
                                vertical
                                key={'key-checkbox-' + index}
                                style={{ width: '100%', margin: mode === 'mobile' ? undefined : '8px 0px' }}
                              >
                                <Row gutter={10} style={{ width: '100%' }}>
                                  <Col
                                    span={24}
                                    md={12}
                                    style={{ margin: mode === 'mobile' ? '0 0 8px 0' : undefined }}
                                    key={`col1` + index}
                                  >
                                    {item.value && (
                                      <Checkbox
                                        key={`col1-${keyElement ?? ''}-${index}`}
                                        value={item.value}
                                        name={name}
                                        disabled={item.disabled}
                                      >
                                        <Typography>{item.label}</Typography>
                                      </Checkbox>
                                    )}
                                  </Col>

                                  <Col
                                    span={24}
                                    md={12}
                                    style={{ margin: mode === 'mobile' ? '0 0 8px 0' : undefined }}
                                    key={`col2` + index}
                                  >
                                    {optionCol2[index]?.value && (
                                      <Checkbox
                                        key={`col2-${keyElement ?? ''}-${index}`}
                                        value={optionCol2[index]?.value}
                                        name={name}
                                        disabled={optionCol2[index]?.disabled}
                                      >
                                        <Typography>{optionCol2[index]?.label}</Typography>
                                      </Checkbox>
                                    )}
                                  </Col>
                                </Row>
                              </Flex>
                            )
                          })}
                        </Form.Item>
                        {index !== options?.length - 1 && <Divider style={{ padding: '0px 0px 16px', margin: 0 }} />}
                      </Flex>
                    </Flex>
                  </Flex>
                )
              })}
          </Checkbox.Group>
        )}
      />
    </Flex>
  )
}
